/* eslint-disable @next/next/no-img-element */
export function NeuralCubeLogo({ className = "", size = 40 }: { className?: string; size?: number }) {
  return (
    <img
      src="/logo_small.png"
      alt=""
      width={size}
      height={size}
      className={`block ${className}`}
    />
  )
}
